module.exports = __webpack_public_path__ + "img/drug-34.a8d9a8da.png";